
import { tryParse, op_Addition, toFloat64, fromParts, compare, toString } from "../../fable_modules/fable-library-js.5.3.0/Decimal.js";
import Decimal from "../../fable_modules/fable-library-js.5.3.0/Decimal.js";
import { join, isNullOrWhiteSpace, printf, toText, trimEnd } from "../../fable_modules/fable-library-js.5.3.0/String.js";
import { localDay } from "../ZonedDate.js";
import { unitsLockedMessage, fillableDays, LogPhase, effectiveToday as effectiveToday_1, DayPermission, permission, Context, phaseOfStatus } from "../DailyLogEditWindow.js";
import { dateHash, equals } from "../../fable_modules/fable-library-js.5.3.0/Util.js";
import { item } from "../../fable_modules/fable-library-js.5.3.0/Array.js";
import { dayNumber, dayOfWeek, day as day_1, month } from "../../fable_modules/fable-library-js.5.3.0/DateOnly.js";
import { min } from "../../fable_modules/fable-library-js.5.3.0/Double.js";
import { filter, map as map_1, tryFind, singleton as singleton_1, ofArray, reverse, head, tail, cons, fold, isEmpty, empty as empty_1, sortDescending, sumBy } from "../../fable_modules/fable-library-js.5.3.0/List.js";
import { compare as compare_1, addDays, equals as equals_1 } from "../../fable_modules/fable-library-js.5.3.0/Date.js";
import { List_distinct } from "../../fable_modules/fable-library-js.5.3.0/Seq2.js";
import { map as map_2, exists, empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.3.0/Seq.js";
import { ofList, FSharpSet__Contains } from "../../fable_modules/fable-library-js.5.3.0/Set.js";
import { flexDirection_flexCol, gap_gap$002D6, display_grid, margin_mb4, padding_p6, boxShadow_shadow, margin_mt8, margin_mt3, padding_py8, textAlign_center, alignItems_itemsStart, margin_mb3, margin_mt4, display_block, borderColor_borderWhite, border_border2, width_w4, height_h4, animation_animateSpin, gap_gap$002D3, fontSize_textLg, gap_gap$002D2, margin_mt2, margin_mt1, fontWeight_fontSemibold, padding_py1, padding_px2, borderRadius_roundedMd, fontSize_textXs, display_inlineBlock, cursor_cursorPointer, gap_gap$002D1, display_inlineFlex, fontWeight_fontMedium, fontSize_textSm, margin_mb2, alignItems_itemsCenter, justifyContent_justifyBetween, display_flex, border_border, padding_p4, borderRadius_roundedLg, tw } from "../../fable_modules/Feliz.Tailwind.4.0.2/Strings.fs.js";
import { grid_gridCols2, md, borderColor_borderTTransparent, borderColor_borderPrimary600, space_spaceY3, textColor_textSecondary600, borderColor_borderSecondary200, backgroundColor_bgSecondary50, borderRadius_roundedFull, textColor_textDanger600, space_spaceY4, textColor_textNeutral700, borderColor_borderNeutral300, textColor_textNeutral800, textColor_textNeutral900, textColor_textWarning800, backgroundColor_bgWarning100, textColor_textPrimary700, hover, textColor_textPrimary600, textColor_textNeutral500, borderColor_borderNeutral200, backgroundColor_bgSurface } from "../TailwindExtensions.js";
import { HtmlHelper_createElement } from "../../fable_modules/Feliz.3.3.3/Html.fs.js";
import { useEffect, useRef, useState, createElement } from "react";
import React from "react";
import { IconWeight, IconSize, IconName, icon } from "../Icons.js";
import { defaultOf } from "../../fable_modules/fable-library-js.5.3.0/Util.js";
import { AddDailyLogRequest, UpdateDailyLogRequest, DailyLogUnitsChange, DailyLogPhotoChange } from "../Shared.js";
import { FSharpRef } from "../../fable_modules/fable-library-js.5.3.0/Types.js";
import { value as value_120, unwrap, toArray, bind, map, defaultArg } from "../../fable_modules/fable-library-js.5.3.0/Option.js";
import { ClientTypes_DailyLogFormTarget, ClientTypes_Route, ClientTypes_Msg, ClientTypes_PhotoUploadState } from "../ClientTypes.js";
import { TailwindHelpers_buttonSecondary, TailwindHelpers_buttonGhost, TailwindHelpers_buttonPrimary, TailwindHelpers_inputField, TailwindHelpers_inputFieldError, TailwindHelpers_labelText } from "../Layout/Layout.js";
import { defaultOf as defaultOf_1 } from "../../fable_modules/fable-library-js.5.3.0/Util.js";
import { DailyLogNote_maxLength } from "../Challenge.js";
import { ImageUploadProps, ImageUploadField } from "../ImageUpload.js";
import { formatsHint } from "../Photo.js";
import { validateDailyLogNote, validateDailyLogTitle } from "./FormUtils.js";
import { skeletonLine } from "../Layout/Interactions.js";

const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

/**
 * Formats stored units for the units input field: the exact value, without trailing zeros.
 * A decimal reaches the client exactly (MsgPack carries its Decimal.GetBits integers), so no
 * rounding is applied; an edit must start from the stored value, not an approximation of it.
 */
export function formatUnitsForInput(value) {
    const text = toString(value);
    if (text.indexOf(".") >= 0) {
        return trimEnd(trimEnd(text, "0"), ".");
    }
    else {
        return text;
    }
}

/**
 * Formats units for read-only display (a log card, a locked units field): one decimal place.
 */
export function formatUnitsForDisplay(value) {
    return toText(printf("%.1f"))(value);
}

/**
 * Edit-window rules context for a challenge as of `now`, given the days already logged.
 */
export function editContext(now, challenge, loggedDays) {
    return new Context(localDay(challenge.Timezone, challenge.StartDate), challenge.Duration, phaseOfStatus(challenge.Status), loggedDays, now, challenge.Timezone);
}

/**
 * Whether an open form target can still be acted on: an add needs a fillable day, an edit a
 * logged day still inside its edit window. A target that fails this renders no form.
 */
export function isFormTargetActionable(ctx, target) {
    if (target.tag === 1) {
        const matchValue = permission(ctx, target.fields[0]);
        switch (matchValue.tag) {
            case 1:
            case 2:
                return true;
            default:
                return false;
        }
    }
    else {
        return equals(permission(ctx, target.fields[0]), new DayPermission(0, []));
    }
}

function formatDate(date) {
    const arg = item(month(date) - 1, monthNames);
    const arg_1 = day_1(date) | 0;
    return toText(printf("%s %d"))(arg)(arg_1);
}

function formatProgress(completed, target, unit) {
    return toText(printf("%.1f / %.0f %s"))(completed)(target)(unit);
}

function progressPercentage(completed, target) {
    if (compare(target, fromParts(0, 0, 0, false, 0)) <= 0) {
        return 0;
    }
    else {
        return min((toFloat64(completed) / toFloat64(target)) * 100, 100);
    }
}

/**
 * Computes the display total from the loaded daily logs once every page is loaded,
 * falling back to the cached challenge TotalUnitsCompleted otherwise. A partial page
 * would under-count, and the cached total can be stale right after a log is saved,
 * so the sum is only trusted when it is complete.
 */
export function computeDisplayTotal(dailyLogs, hasMore, challengeTotal) {
    let logs;
    let matchResult, logs_1;
    if (dailyLogs != null) {
        if ((logs = dailyLogs, !hasMore)) {
            matchResult = 0;
            logs_1 = dailyLogs;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return sumBy((e) => e.Log.UnitsCompleted, logs_1, {
                GetZero: () => (new Decimal("0")),
                Add: op_Addition,
            });
        default:
            return challengeTotal;
    }
}

const weekdayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export function weekdayAndDate(date) {
    const arg = item(dayOfWeek(date), weekdayNames);
    const arg_1 = formatDate(date);
    return toText(printf("%s, %s"))(arg)(arg_1);
}

/**
 * Card and placeholder heading for a day, relative to the challenge's effective today.
 * While Finalizing the effective today is the last day, so the day before it is not
 * literally yesterday and shows its plain date.
 */
export function dayLabel(ctx, date) {
    const plain = weekdayAndDate(date);
    const matchValue = effectiveToday_1(ctx);
    let matchResult, today_2, today_3;
    if (matchValue != null) {
        if (equals_1(date, matchValue)) {
            matchResult = 0;
            today_2 = matchValue;
        }
        else if (equals_1(date, addDays(matchValue, -1)) && equals(ctx.Phase, new LogPhase(0, []))) {
            matchResult = 1;
            today_3 = matchValue;
        }
        else {
            matchResult = 2;
        }
    }
    else {
        matchResult = 2;
    }
    switch (matchResult) {
        case 0: {
            const prefix = (ctx.Phase.tag === 1) ? "Last day" : "Today";
            return toText(printf("%s · %s"))(prefix)(plain);
        }
        case 1:
            return toText(printf("Yesterday · %s"))(plain);
        default:
            return plain;
    }
}

/**
 * Days that belong in the Needs attention group, newest first: effective today, the day
 * before it (when inside the period), then the remaining fillable days.
 */
export function needsAttentionDays(ctx) {
    const matchValue = effectiveToday_1(ctx);
    if (matchValue != null) {
        const today = matchValue;
        const dayBefore = addDays(today, -1);
        return sortDescending(List_distinct(toList(delay(() => append(singleton(today), delay(() => append((compare_1(dayBefore, ctx.StartDay) >= 0) ? singleton(dayBefore) : empty(), delay(() => fillableDays(ctx))))))), {
            Equals: equals_1,
            GetHashCode: (x) => (dateHash(x) | 0),
        }), {
            Compare: (x_1, y_1) => (compare_1(x_1, y_1) | 0),
        });
    }
    else {
        return empty_1();
    }
}

const visiblePlaceholderCount = 3;

/**
 * Splits needs-attention days (newest first, effective today first) into those shown and a
 * count of collapsed placeholders. Today and logged days always show; only missing days
 * after today are collapsed.
 */
export function collapsedMissedDays(days, loggedDates, showAll) {
    if (!isEmpty(days)) {
        const patternInput = fold((tupledArg, day) => {
            const placeholders = tupledArg[0] | 0;
            const visible = tupledArg[1];
            const hidden = tupledArg[2] | 0;
            if (FSharpSet__Contains(loggedDates, day)) {
                return [placeholders, cons(day, visible), hidden];
            }
            else if (showAll ? true : (placeholders < visiblePlaceholderCount)) {
                return [placeholders + 1, cons(day, visible), hidden];
            }
            else {
                return [placeholders, visible, hidden + 1];
            }
        }, [0, empty_1(), 0], tail(days));
        return [cons(head(days), reverse(patternInput[1])), patternInput[2]];
    }
    else {
        return [empty_1(), 0];
    }
}

const dayCardClasses = tw(ofArray([backgroundColor_bgSurface, borderRadius_roundedLg, padding_p4, border_border, borderColor_borderNeutral200]));

export function DailyLogEntryCard(entry, unitType, label, isHidden, onEdit, editDisabled) {
    return HtmlHelper_createElement("div", ofArray([["className", dayCardClasses], ["children", toList(delay(() => append(singleton(HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, justifyContent_justifyBetween, alignItems_itemsCenter, margin_mb2]))], ["children", toList(delay(() => append(singleton(HtmlHelper_createElement("span", ofArray([["className", tw(ofArray([fontSize_textSm, fontWeight_fontMedium, textColor_textNeutral500]))], ["children", singleton_1(label)]]))), delay(() => {
        let edit;
        const matchValue = onEdit;
        let matchResult, edit_1;
        if (matchValue != null) {
            if ((edit = matchValue, !isHidden)) {
                matchResult = 0;
                edit_1 = matchValue;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return singleton(HtmlHelper_createElement("button", ofArray([["className", tw(ofArray([display_inlineFlex, alignItems_itemsCenter, gap_gap$002D1, fontSize_textSm, textColor_textPrimary600, hover(textColor_textPrimary700), cursor_cursorPointer]))], ["disabled", editDisabled], ["aria-disabled", editDisabled], ["onClick", (_arg) => {
                    edit_1();
                }], ["children", [createElement(icon, {
                    name: new IconName(0, []),
                    size: new IconSize(0, []),
                    weight: new IconWeight(0, []),
                }), HtmlHelper_createElement("span", singleton_1(["children", singleton_1("Edit")]))]]])));
            default:
                return singleton(defaultOf());
        }
    }))))]]))), delay(() => append(isHidden ? singleton(HtmlHelper_createElement("span", ofArray([["className", tw(ofArray([display_inlineBlock, backgroundColor_bgWarning100, textColor_textWarning800, fontSize_textXs, fontWeight_fontMedium, borderRadius_roundedMd, padding_px2, padding_py1, margin_mb2]))], ["children", singleton_1("Hidden by a moderator")]]))) : empty(), delay(() => {
        let arg;
        return append(singleton(HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontWeight_fontSemibold, textColor_textNeutral900]))], ["children", singleton_1((arg = formatUnitsForDisplay(entry.UnitsCompleted), toText(printf("%s %s"))(arg)(unitType)))]]))), delay(() => append(singleton(HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontWeight_fontMedium, textColor_textNeutral800, margin_mt1]))], ["children", singleton_1(entry.Title)]]))), delay(() => {
            let matchValue_1, note;
            return append((matchValue_1 = entry.Note, (matchValue_1 == null) ? singleton(defaultOf()) : ((note = matchValue_1, singleton(HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textNeutral500, margin_mt1]))], ["children", singleton_1(note)]])))))), delay(() => {
                const matchValue_2 = entry.PhotoUrl;
                if (matchValue_2 == null) {
                    return singleton(defaultOf());
                }
                else {
                    const url = matchValue_2;
                    return singleton(HtmlHelper_createElement("img", ofArray([["className", tw(ofArray([margin_mt2, "max-w-xs", borderRadius_roundedMd]))], ["src", url], ["alt", "Log photo"]])));
                }
            }));
        }))));
    }))))))]]));
}

/**
 * Placeholder for a day that can still be filled in.
 */
export function MissingDayCard(label, onAdd, disabled) {
    return HtmlHelper_createElement("div", ofArray([["className", tw(ofArray(["border-dashed", borderRadius_roundedLg, padding_p4, border_border, borderColor_borderNeutral300, display_flex, justifyContent_justifyBetween, alignItems_itemsCenter, gap_gap$002D2]))], ["children", [HtmlHelper_createElement("div", ofArray([["className", tw(ofArray(["flex-1", "min-w-0"]))], ["children", [HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, fontWeight_fontMedium, textColor_textNeutral700, "break-words"]))], ["children", singleton_1(label)]])), HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textNeutral500]))], ["children", singleton_1("Not logged")]]))]]])), HtmlHelper_createElement("button", ofArray([["className", tw(ofArray(["shrink-0", "whitespace-nowrap", fontSize_textSm, textColor_textPrimary600, hover(textColor_textPrimary700), cursor_cursorPointer]))], ["disabled", disabled], ["aria-disabled", disabled], ["aria-label", toText(printf("Add log for %s"))(label)], ["onClick", (_arg) => {
        onAdd();
    }], ["children", singleton_1("+ Add log")]]))]]]));
}

/**
 * Status-appropriate copy for the inactive-state info banner.
 * Pre-active statuses anticipate logging; post-active statuses describe history.
 */
export function inactiveStatusMessage(status) {
    switch (status) {
        case "draft":
        case "planned":
        case "published":
        case "pledged":
            return "Daily logging is available once your challenge is active.";
        case "finalizing":
            return "Your challenge has ended. You can still fill missed days and fix your logs until it\'s finalized.";
        case "finalized":
            return "Your challenge is complete. View your log history below.";
        case "abandoned":
            return "This challenge was abandoned. View your log history below.";
        default:
            return "Daily logging is available once your challenge is active.";
    }
}

/**
 * Maps the photo field's state at submit time to the change sent with the log.
 * Remove (NoPhoto) clears an entry that had a photo. A failed or in-flight upload keeps it.
 */
export function photoChangeForSubmit(hadExistingPhoto, state) {
    let matchResult;
    switch (state.tag) {
        case 3:
        case 1:
        case 4: {
            matchResult = 2;
            break;
        }
        case 0: {
            if (hadExistingPhoto) {
                matchResult = 1;
            }
            else {
                matchResult = 2;
            }
            break;
        }
        default:
            matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return new DailyLogPhotoChange(1, [state.fields[0].PhotoKey]);
        case 1:
            return new DailyLogPhotoChange(2, []);
        default:
            return new DailyLogPhotoChange(0, []);
    }
}

/**
 * The key for a new entry (AddDailyLogRequest.PhotoUrl). Only a fresh upload has one.
 */
export function newPhotoKey(change) {
    switch (change.tag) {
        case 0:
        case 2:
            return undefined;
        default:
            return change.fields[0];
    }
}

/**
 * Units for an add request. An add form is never units-locked, so KeepUnits cannot reach here;
 * 0 would be rejected by the server's positive-amount rule if it ever did.
 */
export function unitsForAdd(change) {
    if (change.tag === 0) {
        return fromParts(0, 0, 0, false, 0);
    }
    else {
        return change.fields[0];
    }
}

/**
 * The units change a submitted form sends, or None when the input is not a positive number.
 * Locked units, and an edit whose input still equals the stored units, keep the stored value
 * so the server never rewrites units the host did not change.
 */
export function unitsChangeForSubmit(unitsLocked, storedUnits, unitsInput) {
    if (unitsLocked) {
        return new DailyLogUnitsChange(0, []);
    }
    else {
        let matchValue;
        let outArg = new Decimal("0");
        matchValue = [tryParse(unitsInput, new FSharpRef(() => outArg, (v) => {
            outArg = v;
        })), outArg];
        let matchResult;
        if (matchValue[0]) {
            if (equals(matchValue[1], storedUnits)) {
                matchResult = 0;
            }
            else if (compare(matchValue[1], fromParts(0, 0, 0, false, 0)) > 0) {
                matchResult = 1;
            }
            else {
                matchResult = 2;
            }
        }
        else {
            matchResult = 2;
        }
        switch (matchResult) {
            case 0:
                return new DailyLogUnitsChange(0, []);
            case 1:
                return new DailyLogUnitsChange(1, [matchValue[1]]);
            default:
                return undefined;
        }
    }
}

export function DailyLogEntryForm($props) {
    const authToken = $props.authToken;
    const dispatch = $props.dispatch;
    const photoUpload = $props.photoUpload;
    const submitError = $props.submitError;
    const isSubmitting = $props.isSubmitting;
    const onCancel = $props.onCancel;
    const onSubmit = $props.onSubmit;
    const initialValues = $props.initialValues;
    const onDraftChanged = $props.onDraftChanged;
    const isTodayForm = $props.isTodayForm;
    const unitsLocked = $props.unitsLocked;
    const heading = $props.heading;
    const unitType = $props.unitType;
    const isEdit = initialValues != null;
    const patternInput = useState(defaultArg(map((v) => formatUnitsForInput(v.UnitsCompleted), initialValues), ""));
    const units = patternInput[0];
    const patternInput_1 = useState(defaultArg(map((v_1) => v_1.Title, initialValues), ""));
    const title = patternInput_1[0];
    const patternInput_2 = useState(defaultArg(bind((v_2) => v_2.Note, initialValues), ""));
    const note = patternInput_2[0];
    const patternInput_3 = useState(undefined);
    const unitsError = patternInput_3[0];
    const patternInput_4 = useState(undefined);
    const titleError = patternInput_4[0];
    const patternInput_5 = useState(undefined);
    const noteError = patternInput_5[0];
    const photoChange = photoChangeForSubmit(exists((v_3) => (v_3.PhotoUrl != null), toArray(initialValues)), photoUpload);
    const photoUploading = equals(photoUpload, new ClientTypes_PhotoUploadState(1, []));
    const noteLength = note.length | 0;
    const hasInput = !((isNullOrWhiteSpace(units) && isNullOrWhiteSpace(title)) && isNullOrWhiteSpace(note));
    const lastReportedHasInput = useRef(hasInput);
    useEffect(() => {
        if (lastReportedHasInput.current !== hasInput) {
            lastReportedHasInput.current = hasInput;
            onDraftChanged(hasInput);
        }
    }, [hasInput]);
    return HtmlHelper_createElement("div", ofArray([["className", tw(singleton_1(space_spaceY4))], ["children", toList(delay(() => append(singleton(HtmlHelper_createElement("h4", ofArray([["className", tw(ofArray([fontSize_textLg, fontWeight_fontSemibold, textColor_textNeutral900]))], ["children", singleton_1(heading)]]))), delay(() => {
        let children;
        return append(singleton((children = toList(delay(() => {
            let arg;
            return unitsLocked ? append(singleton(HtmlHelper_createElement("p", ofArray([["className", TailwindHelpers_labelText], ["children", [HtmlHelper_createElement("span", singleton_1(["children", singleton_1((arg = defaultArg(map((v_5) => formatUnitsForDisplay(v_5.UnitsCompleted), initialValues), ""), toText(printf("%s %s"))(arg)(unitType)))])), createElement(icon, {
                name: new IconName(33, []),
                size: new IconSize(0, []),
                weight: new IconWeight(0, []),
            })]]]))), delay(() => singleton(HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textNeutral500, margin_mt1]))], ["children", singleton_1(unitsLockedMessage)]]))))) : append(singleton(HtmlHelper_createElement("label", ofArray([["className", TailwindHelpers_labelText], ["htmlFor", "daily-log-units"], ["children", singleton_1(toText(printf("Units completed (%s)"))(unitType))]]))), delay(() => append(singleton(HtmlHelper_createElement("input", ofArray([["className", (unitsError != null) ? TailwindHelpers_inputFieldError : TailwindHelpers_inputField], ["id", "daily-log-units"], ["type", "number"], ["placeholder", "0"], ["step", 0.1], ["value", units], ["onChange", (ev) => {
                patternInput[1](ev.target.value);
            }], ["disabled", isSubmitting]]))), delay(() => {
                const matchValue_1 = unitsError;
                if (matchValue_1 == null) {
                    return singleton(defaultOf());
                }
                else {
                    const err = matchValue_1;
                    return singleton(HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textDanger600, margin_mt1]))], ["children", singleton_1(err)]])));
                }
            }))));
        })), createElement("div", defaultOf_1(), ...children))), delay(() => {
            let children_3;
            return append(singleton((children_3 = toList(delay(() => append(singleton(HtmlHelper_createElement("label", ofArray([["className", TailwindHelpers_labelText], ["htmlFor", "daily-log-title"], ["children", singleton_1("Title *")]]))), delay(() => append(singleton(HtmlHelper_createElement("input", ofArray([["className", (titleError != null) ? TailwindHelpers_inputFieldError : TailwindHelpers_inputField], ["id", "daily-log-title"], ["type", "text"], ["placeholder", isTodayForm ? "Today\'s summary..." : "Summary for the day..."], ["value", title], ["onChange", (ev_1) => {
                patternInput_1[1](ev_1.target.value);
            }], ["disabled", isSubmitting]]))), delay(() => {
                const matchValue_2 = titleError;
                if (matchValue_2 == null) {
                    return singleton(defaultOf());
                }
                else {
                    const err_1 = matchValue_2;
                    return singleton(HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textDanger600, margin_mt1]))], ["children", singleton_1(err_1)]])));
                }
            })))))), createElement("div", defaultOf_1(), ...children_3))), delay(() => {
                let children_6;
                return append(singleton((children_6 = ofArray([HtmlHelper_createElement("label", ofArray([["className", TailwindHelpers_labelText], ["htmlFor", "daily-log-note"], ["children", singleton_1("Note (optional)")]])), HtmlHelper_createElement("textarea", ofArray([["className", tw(ofArray([(noteError != null) ? TailwindHelpers_inputFieldError : TailwindHelpers_inputField, "min-h-[80px]"]))], ["id", "daily-log-note"], ["placeholder", "Share more details..."], ["value", note], ["onChange", (ev_2) => {
                    patternInput_2[1](ev_2.target.value);
                }], ["disabled", isSubmitting]])), HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, justifyContent_justifyBetween, margin_mt1]))], ["children", toList(delay(() => {
                    let matchValue_3, err_2;
                    return append((matchValue_3 = noteError, (matchValue_3 == null) ? singleton(HtmlHelper_createElement("span", empty_1())) : ((err_2 = matchValue_3, singleton(HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textDanger600]))], ["children", singleton_1(err_2)]])))))), delay(() => singleton(HtmlHelper_createElement("span", ofArray([["className", tw(ofArray([fontSize_textSm, (noteLength > DailyLogNote_maxLength) ? textColor_textDanger600 : textColor_textNeutral500]))], ["children", singleton_1(toText(printf("%d / %d chars"))(noteLength)(DailyLogNote_maxLength))]])))));
                }))]]))]), createElement("div", defaultOf_1(), ...children_6))), delay(() => append(singleton(createElement(ImageUploadField, {
                    props: new ImageUploadProps("daily-log-photo", "Photo (optional)", false, formatsHint, undefined, "Photo preview", tw(ofArray(["max-w-xs", borderRadius_roundedLg])), undefined, photoUpload, isSubmitting, authToken, () => {
                        dispatch(new ClientTypes_Msg(128, []));
                    }, (photo) => {
                        dispatch(new ClientTypes_Msg(129, [photo]));
                    }, (failure) => {
                        dispatch(new ClientTypes_Msg(130, [failure]));
                    }, () => {
                        dispatch(new ClientTypes_Msg(131, []));
                    }),
                })), delay(() => {
                    let matchValue_4, err_3;
                    return append((matchValue_4 = submitError, (matchValue_4 == null) ? singleton(defaultOf()) : ((err_3 = matchValue_4, singleton(HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textDanger600]))], ["children", singleton_1(err_3)]])))))), delay(() => singleton(HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, gap_gap$002D3]))], ["children", toList(delay(() => append(singleton(HtmlHelper_createElement("button", ofArray([["className", tw(ofArray([TailwindHelpers_buttonPrimary, display_flex, alignItems_itemsCenter, gap_gap$002D2]))], ["disabled", isSubmitting ? true : photoUploading], ["onClick", (e) => {
                        e.preventDefault();
                        if (!photoUploading) {
                            const parsedUnits = unitsChangeForSubmit(unitsLocked, map((v_4) => v_4.UnitsCompleted, initialValues), units);
                            const uErr = (parsedUnits == null) ? "Units must be greater than 0" : undefined;
                            const tErr = validateDailyLogTitle(title);
                            const noteVal = isNullOrWhiteSpace(note) ? undefined : note;
                            const nErr = validateDailyLogNote(noteVal);
                            patternInput_3[1](uErr);
                            patternInput_4[1](tErr);
                            patternInput_5[1](nErr);
                            let matchResult;
                            if (uErr == null) {
                                if (tErr == null) {
                                    if (nErr == null) {
                                        if (parsedUnits != null) {
                                            matchResult = 0;
                                        }
                                        else {
                                            matchResult = 1;
                                        }
                                    }
                                    else {
                                        matchResult = 1;
                                    }
                                }
                                else {
                                    matchResult = 1;
                                }
                            }
                            else {
                                matchResult = 1;
                            }
                            switch (matchResult) {
                                case 0: {
                                    onSubmit(parsedUnits, title, noteVal, photoChange);
                                    break;
                                }
                                case 1: {
                                    break;
                                }
                            }
                        }
                    }], ["children", toList(delay(() => append(isSubmitting ? singleton(HtmlHelper_createElement("div", singleton_1(["className", tw(ofArray([animation_animateSpin, borderRadius_roundedFull, height_h4, width_w4, border_border2, borderColor_borderWhite]))]))) : empty(), delay(() => singleton(HtmlHelper_createElement("span", singleton_1(["children", singleton_1(isEdit ? "Save changes" : "Add log")])))))))]]))), delay(() => {
                        const matchValue_5 = onCancel;
                        if (matchValue_5 == null) {
                            return singleton(defaultOf());
                        }
                        else {
                            const cancel = matchValue_5;
                            return singleton(HtmlHelper_createElement("button", ofArray([["className", TailwindHelpers_buttonGhost], ["children", singleton_1("Cancel")], ["onClick", (_arg) => {
                                cancel();
                            }], ["disabled", isSubmitting]])));
                        }
                    }))))]])))));
                }))));
            }));
        }));
    }))))]]));
}

function seeWhatSupportersSeeLink(challengeId, dispatch) {
    return HtmlHelper_createElement("a", ofArray([["className", tw(ofArray([display_block, margin_mt4, fontSize_textSm, fontWeight_fontMedium, textColor_textPrimary600, hover(textColor_textPrimary700), cursor_cursorPointer]))], ["href", toText(printf("/challenges/%s/logs"))(challengeId)], ["children", singleton_1("See what supporters see →")], ["onClick", (e) => {
        e.preventDefault();
        dispatch(new ClientTypes_Msg(37, [new ClientTypes_Route(12, [challengeId])]));
    }]]));
}

function groupHeading(text) {
    return HtmlHelper_createElement("h4", ofArray([["className", tw(ofArray([fontSize_textXs, fontWeight_fontSemibold, textColor_textNeutral500, "tracking-wide", margin_mb3]))], ["children", singleton_1(text)]]));
}

function inactiveStatusBanner(status) {
    return HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, alignItems_itemsStart, gap_gap$002D3, padding_p4, backgroundColor_bgSecondary50, borderRadius_roundedLg, border_border, borderColor_borderSecondary200]))], ["children", [HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([textColor_textSecondary600, "flex-shrink-0"]))], ["children", [createElement(icon, {
        name: new IconName(35, []),
        size: new IconSize(1, []),
        weight: new IconWeight(0, []),
    })]]])), HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textSecondary600]))], ["children", singleton_1(inactiveStatusMessage(status))]]))]]]));
}

function keyed(key, child) {
    return HtmlHelper_createElement("div", ofArray([["key", key], ["children", [child]]]));
}

export function DailyLogSection($props) {
    const dispatch = $props.dispatch;
    const model = $props.model;
    const challenge = $props.challenge;
    const clock = $props.clock;
    const ctx = editContext(clock.UtcNow(), challenge, model.LoggedDays);
    const isWritable = !equals(ctx.Phase, new LogPhase(2, []));
    const isActive = challenge.Status === "active";
    const showsLogs = (isWritable ? true : (challenge.Status === "finalized")) ? true : (challenge.Status === "abandoned");
    const effectiveToday = effectiveToday_1(ctx);
    let authToken;
    const matchValue = model.Auth;
    authToken = ((matchValue.tag === 1) ? matchValue.fields[0] : undefined);
    const logs = defaultArg(model.DailyLogs, empty_1());
    const logFor = (date) => tryFind((l) => equals_1(l.Log.Date, date), logs);
    const loggedDates = ofList(map_1((l_1) => l_1.Log.Date, logs), {
        Compare: (x, y) => (compare_1(x, y) | 0),
    });
    const needsDays = needsAttentionDays(ctx);
    const patternInput = collapsedMissedDays(needsDays, loggedDates, model.ShowAllMissedDays);
    const hiddenMissedCount = patternInput[1] | 0;
    const needsDaysAlreadyLogged = ofList(filter((value_1) => FSharpSet__Contains(loggedDates, value_1), needsDays), {
        Compare: (x_1, y_1) => (compare_1(x_1, y_1) | 0),
    });
    const yourLogs = filter((l_2) => !FSharpSet__Contains(needsDaysAlreadyLogged, l_2.Log.Date), logs);
    const anyFormOpen = ((model.OpenDailyLogForm != null) ? true : model.DailyLogDraftHasInput) ? true : !equals(model.PhotoUpload, new ClientTypes_PhotoUploadState(0, []));
    const isFormOpenFor = (date_1) => {
        const matchValue_1 = model.OpenDailyLogForm;
        let matchResult, d;
        if (matchValue_1 == null) {
            matchResult = 1;
        }
        else if (matchValue_1.tag === 1) {
            matchResult = 0;
            d = matchValue_1.fields[0];
        }
        else {
            matchResult = 0;
            d = matchValue_1.fields[0];
        }
        switch (matchResult) {
            case 0:
                return equals_1(d, date_1);
            default:
                if (equals(date_1, effectiveToday)) {
                    return logFor(date_1) == null;
                }
                else {
                    return false;
                }
        }
    };
    const displayTotal = computeDisplayTotal(model.DailyLogs, model.DailyLogsHasMore, challenge.TotalUnitsCompleted);
    const logForm = (date_2, existing) => {
        let arg_2, arg_3;
        const isEdit = existing != null;
        const isToday = equals(date_2, effectiveToday);
        let heading;
        if (isToday) {
            heading = dayLabel(ctx, date_2);
        }
        else {
            const arg = isEdit ? "Edit" : "Log for";
            const arg_1 = weekdayAndDate(date_2);
            heading = toText(printf("%s %s"))(arg)(arg_1);
        }
        const unitsLocked = equals(permission(ctx, date_2), new DayPermission(2, []));
        const onCancel = (model.OpenDailyLogForm != null) ? (() => {
            dispatch(new ClientTypes_Msg(106, []));
        }) : undefined;
        return keyed((arg_2 = (dayNumber(date_2) | 0), (arg_3 = (isEdit ? "edit" : "add"), toText(printf("%d-form-%s"))(arg_2)(arg_3))), createElement(DailyLogEntryForm, {
            unitType: challenge.Unit,
            heading: heading,
            unitsLocked: unitsLocked,
            isTodayForm: isToday,
            onDraftChanged: (hasInput) => {
                dispatch(new ClientTypes_Msg(107, [hasInput]));
            },
            initialValues: unwrap(existing),
            onSubmit: (units, title, note, photoChange) => {
                if (isEdit) {
                    dispatch(new ClientTypes_Msg(113, [new UpdateDailyLogRequest(challenge.Id, date_2, units, title, note, photoChange)]));
                }
                else {
                    dispatch(new ClientTypes_Msg(111, [new AddDailyLogRequest(challenge.Id, date_2, unitsForAdd(units), title, note, newPhotoKey(photoChange))]));
                }
            },
            onCancel: unwrap(onCancel),
            isSubmitting: model.SubmittingDailyLog,
            submitError: unwrap(model.DailyLogSubmitError),
            photoUpload: model.PhotoUpload,
            dispatch: dispatch,
            authToken: unwrap(authToken),
        }));
    };
    const logCard = (entry) => {
        let arg_4;
        const date_3 = entry.Log.Date;
        if (isFormOpenFor(date_3)) {
            return logForm(date_3, entry.Log);
        }
        else {
            let onEdit;
            const matchValue_2 = permission(ctx, date_3);
            switch (matchValue_2.tag) {
                case 0:
                case 3: {
                    onEdit = undefined;
                    break;
                }
                default:
                    onEdit = (() => {
                        dispatch(new ClientTypes_Msg(105, [new ClientTypes_DailyLogFormTarget(1, [date_3]), entry.Log.PhotoUrl]));
                    });
            }
            return keyed((arg_4 = (dayNumber(date_3) | 0), toText(printf("%d-card"))(arg_4)), DailyLogEntryCard(entry.Log, challenge.Unit, dayLabel(ctx, date_3), entry.IsHidden, onEdit, anyFormOpen));
        }
    };
    const needsAttentionGroup = HtmlHelper_createElement("div", singleton_1(["children", [groupHeading("NEEDS ATTENTION"), HtmlHelper_createElement("div", ofArray([["className", tw(singleton_1(space_spaceY3))], ["children", toList(delay(() => append(map_2((date_5) => {
        let arg_5;
        const date_4 = date_5;
        const matchValue_3 = logFor(date_4);
        return (matchValue_3 == null) ? (isFormOpenFor(date_4) ? logForm(date_4, undefined) : keyed((arg_5 = (dayNumber(date_4) | 0), toText(printf("%d-missing"))(arg_5)), MissingDayCard(dayLabel(ctx, date_4), () => {
            dispatch(new ClientTypes_Msg(105, [new ClientTypes_DailyLogFormTarget(0, [date_4]), undefined]));
        }, anyFormOpen))) : logCard(matchValue_3);
    }, patternInput[0]), delay(() => ((hiddenMissedCount > 0) ? singleton(HtmlHelper_createElement("button", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textPrimary600, hover(textColor_textPrimary700), cursor_cursorPointer]))], ["children", singleton_1((hiddenMissedCount === 1) ? "+ 1 more missed day" : toText(printf("+ %d more missed days"))(hiddenMissedCount))], ["onClick", (_arg) => {
        dispatch(new ClientTypes_Msg(108, []));
    }]]))) : empty())))))]]))]]));
    const loadMoreSpinner = HtmlHelper_createElement("div", ofArray([["aria-hidden", "true"], ["className", tw(ofArray([animation_animateSpin, borderRadius_roundedFull, height_h4, width_w4, border_border2, borderColor_borderPrimary600, borderColor_borderTTransparent]))]]));
    const yourLogsGroup = HtmlHelper_createElement("div", singleton_1(["children", toList(delay(() => append(singleton(groupHeading("YOUR LOGS")), delay(() => append(isEmpty(logs) ? singleton(HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textNeutral500, textAlign_center, padding_py8]))], ["children", singleton_1("No entries yet — log your first day of progress!")]]))) : empty(), delay(() => append(singleton(HtmlHelper_createElement("div", ofArray([["className", tw(singleton_1(space_spaceY3))], ["children", toList(delay(() => map_2(logCard, yourLogs)))]]))), delay(() => append(model.DailyLogsHasMore ? singleton(HtmlHelper_createElement("button", ofArray([["className", tw(ofArray([TailwindHelpers_buttonSecondary, margin_mt3, display_inlineFlex, alignItems_itemsCenter, gap_gap$002D2]))], ["disabled", model.LoadingMoreDailyLogs], ["onClick", (_arg_1) => {
        dispatch(new ClientTypes_Msg(102, []));
    }], ["children", toList(delay(() => append(model.LoadingMoreDailyLogs ? singleton(loadMoreSpinner) : empty(), delay(() => singleton(HtmlHelper_createElement("span", singleton_1(["children", singleton_1("Load more")])))))))]]))) : empty(), delay(() => {
        let matchValue_4, err;
        return append((matchValue_4 = model.DailyLogsLoadMoreError, (matchValue_4 == null) ? singleton(defaultOf()) : ((err = matchValue_4, singleton(HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([margin_mt3, display_flex, alignItems_itemsCenter, gap_gap$002D3]))], ["children", [HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textDanger600]))], ["children", singleton_1(err)]])), HtmlHelper_createElement("button", ofArray([["className", TailwindHelpers_buttonSecondary], ["children", singleton_1("Retry")], ["onClick", (_arg_2) => {
            dispatch(new ClientTypes_Msg(102, []));
        }]]))]]])))))), delay(() => singleton(seeWhatSupportersSeeLink(challenge.Id, dispatch))));
    }))))))))))]));
    return HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([margin_mt8, backgroundColor_bgSurface, borderRadius_roundedLg, boxShadow_shadow, padding_p6]))], ["children", toList(delay(() => append(singleton(HtmlHelper_createElement("div", ofArray([["className", tw(singleton_1(margin_mb4))], ["children", toList(delay(() => append(singleton(HtmlHelper_createElement("h3", ofArray([["className", tw(ofArray([fontSize_textLg, fontWeight_fontSemibold, textColor_textNeutral900]))], ["children", singleton_1("Daily Progress Log")]]))), delay(() => (isWritable ? singleton(HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textNeutral500, margin_mt1]))], ["children", singleton_1(formatProgress(displayTotal, challenge.TargetAmount, challenge.Unit))]]))) : empty())))))]]))), delay(() => append(!isActive ? singleton(inactiveStatusBanner(challenge.Status)) : empty(), delay(() => {
        let matchValue_6, err_1, err_2;
        return append((matchValue_6 = model.DailyLogSubmitError, (model.OpenDailyLogForm == null) ? ((matchValue_6 != null) ? (((err_1 = matchValue_6, !((effectiveToday != null) && (logFor(value_120(effectiveToday)) == null)))) ? ((err_2 = matchValue_6, singleton(HtmlHelper_createElement("p", ofArray([["role", join(" ", ["alert"])], ["className", tw(ofArray([fontSize_textSm, textColor_textDanger600, margin_mt2]))], ["children", singleton_1(err_2)]]))))) : singleton(defaultOf())) : singleton(defaultOf())) : singleton(defaultOf())), delay(() => {
            if (showsLogs) {
                if (model.LoadingDailyLogs) {
                    return singleton(HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([space_spaceY3, margin_mt4]))], ["children", [skeletonLine(80), skeletonLine(60), skeletonLine(40)]]])));
                }
                else {
                    const matchValue_8 = model.DailyLogsError;
                    if (matchValue_8 == null) {
                        return singleton(HtmlHelper_createElement("div", ofArray([["className", isWritable ? tw(ofArray([display_grid, md(grid_gridCols2), gap_gap$002D6, margin_mt4])) : tw(singleton_1(margin_mt4))], ["children", toList(delay(() => append(isWritable ? singleton(needsAttentionGroup) : empty(), delay(() => singleton(yourLogsGroup)))))]])));
                    }
                    else {
                        const err_3 = matchValue_8;
                        return singleton(HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, flexDirection_flexCol, alignItems_itemsCenter, padding_py8, gap_gap$002D3]))], ["children", [HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textDanger600]))], ["children", singleton_1(err_3)]])), HtmlHelper_createElement("button", ofArray([["className", TailwindHelpers_buttonSecondary], ["children", singleton_1("Retry")], ["onClick", (_arg_3) => {
                            dispatch(new ClientTypes_Msg(100, [challenge.Id]));
                        }]]))]]])));
                    }
                }
            }
            else {
                return singleton(seeWhatSupportersSeeLink(challenge.Id, dispatch));
            }
        }));
    }))))))]]));
}

//# sourceMappingURL=DailyLogView.js.map
